<template>
  <div
    class="rounded-xl p-10 md:p-6"
    :class="[
      mode === 'dark' ? 'bg-dark-sidebar' : 'bg-white-100 shadow-primary',
    ]"
  >
    <div class="mb-6 text-primary-100">
      <component :is="item.icon" :size="48" :stroke-width="1" />
    </div>
    <div
      class="mb-6 border-b pb-6"
      :class="[mode === 'dark' ? 'border-dark-border' : 'border-border-100']"
    >
      <h2
        class="min-h-[66px] overflow-hidden text-[22px] font-semibold sm:min-h-max"
      >
        {{ item.title }}
      </h2>
    </div>
    <div class="mb-6">
      <p
        class="mb-4 text-[18px] font-medium tracking-tight"
        :class="[mode === 'dark' ? 'text-white-100' : 'text-black-80']"
        v-html="item.subTitle"
      />
      <ul class="grid list-disc gap-2 pl-4">
        <li
          v-for="(i, key) in item.list"
          :key="key"
          class="text-[18px] font-medium leading-none text-primary-50"
        >
          <span
            class="text-[14px]"
            :class="[mode === 'dark' ? 'text-dark-text' : 'text-black-60']"
            >{{ i }}</span
          >
        </li>
      </ul>
    </div>
    <div>
      <AppButton
        :isLink="true"
        :to="item.link"
        :title="item.linkText"
        type="secondary"
      />
    </div>
  </div>
</template>

<script>
import AppButton from "@C/Common/AppButton.vue";

export default {
  name: "IconCard",
  props: {
    mode: String,
    item: {
      type: Object,
      default: () => ({
        icon: null,
        title: "",
        subTitle: "",
        list: [],
        link: "",
        linkText: "",
      }),
    },
  },
  components: {
    AppButton,
  },
};
</script>
